import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
// @mui
import { Stack, IconButton, InputAdornment, TextField, createTheme, ThemeProvider, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Swal from 'sweetalert2';
import { authService } from '../../../services/authService';
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const theme = createTheme({
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              border: '2px solid white', // Replace 'red' with your desired border color
            },
            '&:hover fieldset': {
              borderColor: '#5756A2', // Replace 'blue' with your desired hover color
            },
          },
        },
      },
    },
  },
});

export default function LoginForm() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [password, setPassword] = useState('');
  const { email } = useParams();
  const queryParams = new URLSearchParams(window.location.search);
  const locationId = queryParams.get('locationId');

  const Navigate = useNavigate();

  useEffect(() => {
    if (!email || !locationId) {
      navigate('/404');
    } else {
      const emailLower = email.toLowerCase();
      if (validateEmail(emailLower)) {
        const previousEmail = localStorage.getItem('email');
        if (previousEmail) {
          if (previousEmail === emailLower) {
            const sessionExpired = localStorage.getItem('sessionExpired');
            if (!sessionExpired) {
              const auth = localStorage.getItem('accessToken');
              if (auth) {
                navigate(`/dashboard/app/`);
              }
            }
          }
        }
      }
    }
  }, [email, locationId, navigate]);

  const landlogin = (event) => {
    event?.preventDefault();
    if (!email || !password || !locationId) {
      Swal.fire({
        title: 'Email, password and locationId are required',
        icon: 'error',
      });
      return;
    }

    setLoader(true);
    authService
      .login({ email, password, locationId })
      .then((response) => {
        authService.persistSession({
          accessToken: response?.accessToken,
          refreshToken: response?.refreshToken,
          locationId,
          email: email.toLowerCase(),
        });

        if (response?.accessToken) {
          Navigate('/dashboard/app');
        }
      })
      .catch((resError) => {
        const errorMessage =
          resError?.response?.data?.message || resError?.message || 'Login failed.';
        Swal.fire({
          title: errorMessage,
          icon: 'error',
        });
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const [showPassword, setShowPassword] = useState(false);
  const validateEmail = (email) => {
    const reg =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return reg.test(email);
  };

  if (!validateEmail(email)) {
    return (
      <Typography variant="h3" sx={{ mt: 5, mb: 2, mx: 'auto', color: 'black' }}>
        Email should be valid and url will be /login/:email
      </Typography>
    );
  }

  return (
    <>
      <form onSubmit={landlogin}>
        <Stack spacing={3}>
          <ThemeProvider theme={theme}>
            <div>
              Account: <strong>{locationId}</strong>
              <br />
              Email: <strong>{email.toLowerCase()}</strong>
            </div>
            <TextField
              name="Password"
              label="Password"
              placeholder="Enter account password"
              onChange={(e) => setPassword(e.target.value)}
              variant="filled"
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" sx={{}}>
                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                      <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <div className="mt-0 d-flex flex-row-reverse">
              <Link className="my-2 text-black" to={`/forgot/${email}?locationId=${locationId}`}>
                <small>Forgot password?</small>
              </Link>
            </div>
          </ThemeProvider>
        </Stack>

        <LoadingButton
          loading={loader}
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          sx={{ marginTop: 5, color: '#FFF', backgroundColor: '#012367' }}
        >
          Login
        </LoadingButton>
      </form>
    </>
  );
}
